/*
* @Author: Abhi Bhatt
* @Date:   2021-12-03 12:32:00
* @Last Modified by:   Abhi Bhatt
* @Last Modified time: 2021-12-03 12:32:24
*/
export const waitUntilElementExists = (selector, callback) => {
const el = document.querySelector(selector);

if (el){
    return callback(el);
}

setTimeout(() => waitUntilElementExists(selector, callback), 500);
}